<template>
  <div>
    <el-row>
      <el-col :span="16">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="Email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>

          <!-- <el-form-item label="Password">
                <el-input v-model="form.password"></el-input>
            </el-form-item> -->

          <el-form-item>
            <el-button type="primary" @click="logIn">Log in</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import gql from "graphql-tag";
import jwt from "jsonwebtoken";

export default {
  name: "Login",
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      login: true,
      valid: false,
      showPassword: false,
      rules: {
        required: v => !!v || "This field is required",
        noSpaces: v => (v || "").indexOf(" ") < 0 || "No spaces are allowed"
      },
      emailRules: {
        valid: v => /.+@.+/.test(v) || "Email must be valid"
      },
      passwordRules: {
        min: v => v.length >= 8 || "Password must be 8 or more characters"
      }
    };
  },
  methods: {
    /* encrypt(password) {
    },
    validatePassword(storeHash) {
    }, */
    signToken(data) {
      return jwt.sign(
        {
          data: data
        },
        process.env.VUE_APP_JWT_TOKEN,
        { expiresIn: "24h" }
      );
    },
    setJWT(name, data) {
      if (!this.$session.exists()) this.$session.start();
      this.$session.set(name, this.signToken(data));
    },
    verifyToken(token) {
      try {
        return jwt.verify(token, process.env.VUE_APP_JWT_TOKEN);
      } catch (err) {
        console.log(err);
      }
    },
    getJWT(name) {
      return this.verifyToken(this.$session.get(name));
    },
    logIn() {
      const self = this;

      this.$apollo
        .query({
          query: gql`
            query($email: String!) {
              User(email: $email, first: 1) {
                ID
                email
                display_name
                contact
                # pass
                Company(first: 1) {
                  name
                }
              }
            }
          `,
          variables: {
            email: this.form.email
          }
        })
        .then(response => {
          switch (response.networkStatus) {
            case 7: {
              let user = response.data.User[0];
              console.log(user);

              /* if (!(self.validatePassword(user.password))) {
                                  console.log('invalid password');
                                  return;
                              } */

              self.setJWT("user", user);

              self.$router.push("/my-dashboard");

              break;
            }
            case 8: {
              console.log("error validating login");
              console.log(response);
              break;
            }
            default: {
              return;
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-btn {
  margin: 1rem 0;
}
</style>
